import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import router from './router'
import store from './store'
import VueMoment from 'vue-moment'
import 'moment/locale/es'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Filters from './filters'
import ('./assets/images/logofd.png')

const endpoint = __API__
Vue.prototype.$endpoint = endpoint


const axiosInstance = axios.create({
  baseURL: endpoint + 'api/',
  timeout: 240000,
})
Vue.use(VueAxios, axiosInstance)
Vue.use(VueMoment)
Vue.use(Buefy, {
  defaultDayNames: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  defaultMonthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
})


Vue.prototype.$eventHub = new Vue(); // Global event bus

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js